/**
 * EconomicEventsPlaceholder Widget
 *
 * Placeholder for the Economic Events banner widget.
 * Future WU provides real economic calendar data.
 *
 * @see types/shared/BannerWidget.ts — BannerWidgetComponentProps contract
 * @see widgetComponentRegistry.ts — component mapping
 */

import React from 'react';
import { Calendar } from 'lucide-react';

import type { BannerWidgetComponentProps } from '@/types/shared/BannerWidget';

export const EconomicEventsPlaceholder: React.FC<BannerWidgetComponentProps> = () => {
  return (
    <div className="flex items-center gap-1.5 text-xs text-default-400 whitespace-nowrap">
      <Calendar size={14} className="shrink-0" />
      <span>Economic events — coming soon</span>
    </div>
  );
};
